<template>
  <div v-if="cbtUnlicensedError" id="testOutput_slide" class="p-test-detail">
    <div class="c-table-no-data">
      <p class="c-parts-text-alert">
        <span class="u-text-bold">{{ cbtUnlicensedError }}</span>
      </p>
    </div>
  </div>
  <div v-else id="testOutput_slide" class="p-test-detail">
    <p>ダウンロードしたい集計結果の項目を選択してください。</p>
    <div class="p-test-form-wrapper">
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle -center">年度</dt>
        <dd class="p-test-form__contents">
          <div class="c-form-select -status jsSelectBox p-test-form__half-select">
            <div class="output" data-unique_id="academic_session_year">
              <input type="hidden" name="academic_session_year" :value="selectedAcademicSession?.value">
              <div class="label">{{ selectedAcademicSession?.name }}</div>
              <div class="arrow"></div>
            </div>
            <div class="option">
              <ul class="option__list">
                <li
                  v-for="academic_session in cbtYearClasses?.academic_sessions"
                  :key="academic_session.value"
                  :data-select-value="academic_session.value"
                  :data-is-selected="academic_session.value === selectedAcademicSession?.value ? 'selected' : undefined"
                  @click="changeAcademicSession(academic_session)"
                >
                  <span class="label">{{ academic_session.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </dd>
      </dl>
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle -center">学年</dt>
        <dd class="p-test-form__contents">
          <div class="c-form-radio-area">
            <label
              v-for="[academicYear, has_license] in academicYearsForRendering"
              :key="academicYear.value"
              class="c-form-radio"
              :class="{ '-disabled': !selectedAcademicSession || !has_license }"
              :for="'grade2' + academicYear.value"
            >
              <input
                type="radio"
                name="grade2"
                :value="academicYear.value"
                :id="'grade2' + academicYear.value"
                class="c-form-radio__input"
                :checked="selectedAcademicYear === academicYear"
                :disabled="!selectedAcademicSession || !has_license"
                @change="changeAcademicYear(academicYear)"
              >
              <span class="c-form-radio__label">{{ academicYear.name }}生</span>
            </label>
          </div>
        </dd>
      </dl>
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle -center">学級</dt>
        <dd class="p-test-form__contents">
          <label class="c-form-checkbox-area" for="class-all" :class="{ '-disabled': !selectedAcademicYear }">
            <input
              type="checkbox"
              class="c-form-checkbox"
              id="class-all"
              @change="checkAllClassroom()"
              :disabled="!selectedAcademicYear"
              :checked="isAllCheckedClassroom"
            >
            <span class="c-form-checkbox-label -large">全学級</span>
          </label>
          <div class="p-test-form__class">
            <label
              class="c-form-checkbox-area class-item"
              :class="{ '-disabled': !selectedAcademicYear }"
              :for="'class-' + classroom.value"
              v-for="classroom in classrooms"
              :key="classroom.value"
            >
              <input
                type="checkbox"
                class="c-form-checkbox"
                :id="'class-' + classroom.value"
                :disabled="!selectedAcademicYear"
                :value="classroom.value"
                v-model="checkedClassroom"
              >
              <span class="c-form-checkbox-label -large">{{ classroom.name }}</span>
            </label>
          </div>
        </dd>
      </dl>
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle">教科</dt>
        <dd class="p-test-form__contents">
          <div class="c-form-radio-area">
            <label
              v-for="subjectField in subjectFieldsForRendering"
              :key="subjectField.id"
              class="c-form-radio"
              :class="{ '-disabled': !selectedAcademicYear || !subjectField.has_license }"
              :for="'subject2' + subjectField.id"
            >
              <input
                type="radio"
                name="subject2"
                :value="subjectField.id"
                :id="'subject2' + subjectField.id"
                class="c-form-radio__input"
                :checked="selectedSubjectField === subjectField"
                :disabled="!selectedAcademicYear || !subjectField.has_license"
                @change="changeSubjectField(subjectField)"
              >
              <span class="c-form-radio__label">{{ subjectField.name }}</span>
            </label>
          </div>
        </dd>
      </dl>
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle">項目</dt>
        <dd class="p-test-form__contents">
          <div class="p-test-form__test-list">
            <label class="c-form-checkbox-area -full" for="test-all" :class="{ '-disabled': !selectedSubjectField }">
              <input
                type="checkbox"
                class="c-form-checkbox"
                id="test-all"
                @change="checkAllUnit()"
                :disabled="!selectedSubjectField"
                :checked="isAllCheckedUnit"
              >
              <span class="c-form-checkbox-label -large">全ての項目</span>
            </label>
            <label
              class="c-form-checkbox-area -full"
              :class="{ '-disabled': !selectedSubjectField }"
              v-for="cbt_unit in cbtUnits?.cbt_units"
              :key="cbt_unit.id"
              :for="'test-' + cbt_unit.id"
            >
              <input
                type="checkbox"
                class="c-form-checkbox"
                :id="'test-' + cbt_unit.id"
                :disabled="!selectedSubjectField"
                :value="cbt_unit.id"
                v-model="checkedUnit"
              >
              <span class="c-form-checkbox-label -large"><div class="u-text-ellipsis">
                <plain-text-view :markdownText="cbt_unit.title"/>
              </div></span>
            </label>
          </div>
        </dd>
      </dl>
    </div>
    <div class="c-button -center">
      <button class="c-button-blue -prefix-icon -download" v-bind="downloadButtonAttrs" @click="downloadFile()">
        <span class="label">ダウンロード（Excel）</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted, watch } from "vue";
  import { useCbtStore } from "@/store/teacher/cbt_store";
  import {
    ICbtYearClassSelectOptions,
    ISelectSingleOption,
    ICbtSubjectFieldSelectOption,
    ICbtUnitsData,
  } from "@/consts/interfaces";

  const cbtStore = useCbtStore();
  // NFR-6855: disable download button untill download complete, to prevent multiple downloads
  const isDownloading = ref<boolean>(false);
  // 先生の学校にCBT教材ライセンスがないエラー
  const cbtUnlicensedError = ref<string>("");

  // 「年度」「学年」「学級」の選択肢
  const cbtYearClasses = ref<ICbtYearClassSelectOptions | null>(null);
  // 「教科」の選択肢
  const cbtSubjectFields = ref<ICbtSubjectFieldSelectOption[] | null>(null);
  // 「項目」の選択肢
  const cbtUnits = ref<ICbtUnitsData | null>(null);

  // 各フィールドで選択中の値
  const selectedAcademicSession = ref<ISelectSingleOption | null>(null);
  const selectedAcademicYear = ref<ISelectSingleOption | null>(null);
  const checkedClassroom = ref<string[]>([]);
  const selectedSubjectField = ref<ICbtSubjectFieldSelectOption | null>(null);
  const checkedUnit = ref<number[]>([]);

  const isAllCheckedClassroom = computed(() =>
    classrooms.value.length > 0 && checkedClassroom.value.length === classrooms.value.length
  );

  const isAllCheckedUnit = computed(() =>
    cbtUnits.value?.cbt_units.length > 0 && checkedUnit.value.length === cbtUnits.value.cbt_units.length
  );

  onMounted(async () => {
    // 「年度」「学年」「学級」の選択肢を取得
    const cbtYearClassResponse:any = await cbtStore.fetchCbtYearClass() ?? null;

    if ("E005" === cbtYearClassResponse?.code) {
      // エラー、かつ、404 (有効なCBT教材のライセンスがありません) の場合
      cbtUnlicensedError.value = cbtYearClassResponse.title;
      return;
    }
    cbtYearClasses.value = cbtYearClassResponse;

    // FIXME: 有効なライセンスが無かったとき（fetchCbtYearClass でエラーレスポンスが返ってきたとき）に
    // ブランクページを表示するパターンは、NFR-6802 で考慮する（「実施状況」の NFR-6673 の対応が参考になるかも）

    // 「年度」は降順で取得されたもののうち、先頭の最新年度を初期値としてセット
    if (cbtYearClasses.value?.academic_sessions.length > 0) {
      selectedAcademicSession.value = cbtYearClasses.value.academic_sessions[0];
    }
  });

  // 「学年」「学級」の選択肢は、選択中の値に応じて、算出プロパティで取得する
  const academicYears = computed(() => {
    // 「学年」の選択肢が取得されていない、または「年度」が未選択の場合は、空の配列を返す
    if (!cbtYearClasses.value || !selectedAcademicSession.value) {
      return [];
    }
    // 選択中の「年度」に対応する学年一覧を返す
    // もし対応する学年一覧が存在しない場合は、空の配列を返す
    return cbtYearClasses.value.academic_years[selectedAcademicSession.value.value] ?? [];
  });

  const classrooms = computed(() => {
    // 「学級」の選択肢が取得されていない、または「年度」か「学年」が未選択の場合は、空の配列を返す
    if (!cbtYearClasses.value || !selectedAcademicSession.value || !selectedAcademicYear.value) {
      return [];
    }
    // 選択中の「年度」「学年」に対応する学級一覧を返す
    // もし対応する学級一覧が存在しない場合は、空の配列を返す
    return cbtYearClasses.value.classrooms[selectedAcademicSession.value.value]?.[selectedAcademicYear.value.value] ?? [];
  });

  // 「年度」「学年」の選択肢が変更されたときに「教科」の選択肢を更新
  watch([selectedAcademicSession, selectedAcademicYear], async () => {
    // 「年度」「学年」のいずれかが未選択の場合は、「教科」の選択肢はクリアする
    if (!selectedAcademicSession.value || !selectedAcademicYear.value) {
      cbtSubjectFields.value = null;
      return;
    }
    // 「年度」「学年」のすべてが選択中の場合は、「教科」の選択肢を取得
    cbtSubjectFields.value = await cbtStore.fetchCbtSubjectFields(
      {
        academic_session_id: Number(selectedAcademicSession.value.value),
        academic_year: Number(selectedAcademicYear.value.value),
      }
    ) ?? null;
  });

  // 「年度」「学年」「教科」の選択肢が変更されたときに「項目」の選択肢を更新
  watch([selectedAcademicSession, selectedAcademicYear, selectedSubjectField], async () => {
    // 「年度」「学年」「教科」のいずれかが未選択の場合は、「項目」の選択肢はクリアする
    if (!selectedAcademicSession.value || !selectedAcademicYear.value || !selectedSubjectField.value) {
      cbtUnits.value = null;
      return;
    }
    // 「年度」「学年」「教科」のすべてが選択中の場合は、「項目」の選択肢を取得
    cbtUnits.value = await cbtStore.fetchCbtUnits(
      {
        academic_session_id: Number(selectedAcademicSession.value.value),
        academic_year: Number(selectedAcademicYear.value.value),
        subject_field_id: Number(selectedSubjectField.value.id),
      }
    ) ?? null;
  });

  // 「学年」の選択肢は、学校種別に応じた全学年に対して、
  // ライセンスが存在するかどうかのフラグを tuple 形式で持たせるようにする
  // * ライセンスがある学年 -> フラグは true
  // * ライセンスがない学年 -> フラグは false
  const academicYearsForRendering = computed(() =>
    (cbtYearClasses.value?.all_academic_years_by_school_type ?? []).map(academicYear => {
      const option = academicYears.value.find(
        opt => opt.value === academicYear.value
      );
      return option ? [option, true] : [academicYear, false];
    })
  );

  // 「教科」の選択肢は、まだAPIで受け取っていないときは、全教科ライセンスなしのデフォルト値が使われるようにする
  const subjectFieldsForRendering = computed(() => {
    if (cbtSubjectFields.value) {
      return cbtSubjectFields.value;
    }

    // 「教科」の選択肢のデフォルト値（全教科ライセンスなし）
    // * 「年度」「学年」が選択されて、APIで選択肢が取得されるまでは、全教科が disabled で表示されるように、has_license はすべて false としておく
    // * 実際にDBから取得した値ではないので、id にも仮の値の 0 をセットしておく
    // * ログイン中の先生の学校種別に応じて、デフォルトの教科を出し分ける
    const defaultSubjectFields = cbtYearClasses.value?.school_type_code === 1
      ? ["国語", "算数", "理科", "社会", "英語"]
      : ["国語", "地理", "歴史", "公民", "数学", "理科", "英語"];

    return defaultSubjectFields.map(
      subject_field => ({"id": 0, "name": subject_field, "has_license": false})
    );
  });

  // 各フィールドの選択時のイベントハンドラ
  function changeAcademicSession(academicSession: ISelectSingleOption) {
    selectedAcademicSession.value = academicSession;
    // 「年度」を変更した場合、「学年」「学級」「教科」「項目」で選択中の値はリセット
    selectedAcademicYear.value = null;
    checkedClassroom.value = [];
    selectedSubjectField.value = null;
    checkedUnit.value = [];
  }
  function changeAcademicYear(academicYear: ISelectSingleOption) {
    selectedAcademicYear.value = academicYear;
    // 「学年」を変更した場合、「学級」「教科」「項目」で選択中の値はリセット
    checkedClassroom.value = [];
    selectedSubjectField.value = null;
    checkedUnit.value = [];
  }
  function checkAllClassroom() {
    if (isAllCheckedClassroom.value) {
      // 全学級が選択中の場合は、全選択を解除
      checkedClassroom.value = [];
    } else {
      // 全学級が未選択の場合は、全学級を選択
      checkedClassroom.value = classrooms.value.map(classroom => classroom.value);
    }
  }
  function changeSubjectField(subjectField: ICbtSubjectFieldSelectOption) {
    selectedSubjectField.value = subjectField;
    // 「教科」を変更した場合、「項目」で選択中の値はリセット
    checkedUnit.value = [];
  }
  function checkAllUnit() {
    if (isAllCheckedUnit.value) {
      // 全項目が選択中の場合は、全選択を解除
      checkedUnit.value = [];
    } else {
      // 全項目が未選択の場合は、全項目を選択
      checkedUnit.value = cbtUnits.value?.cbt_units.map(cbt_unit => cbt_unit.id) || [];
    }
  }
  // ダウンロードボタンの属性
  const downloadButtonAttrs = computed(() => {
    // ダウンロードに必要な条件を満たしていない場合は、ボタンを無効化
    const allSelected =
      selectedAcademicSession.value &&
      selectedAcademicYear.value &&
      checkedClassroom.value.length > 0 &&
      selectedSubjectField.value &&
      checkedUnit.value.length > 0 &&
      !isDownloading.value;
    if (!allSelected) {
      return {class: {'-disabled': true}};
    }
    return {class: {'-disabled': false}};
  });
  // NFR-6855: downloadFile 関数内で、ダウンロード処理中は isDownloading を true にして、ダウンロード完了後に false に戻すようにする
  async function downloadFile() {
    if (isDownloading.value) {
      return;
    }
    isDownloading.value = true;
    try {
      // ダウンロード処理（APIリクエストなど）をここに実装
      await cbtStore.exportCbtScoreResults({ 
        classroom_uuids: checkedClassroom.value.map(id => id),
        cbt_unit_ids: checkedUnit.value,
      });
    } finally {
      isDownloading.value = false;
    }
  }
</script>

<style scoped>
</style>
